import { render, staticRenderFns } from "./IklanBaris.vue?vue&type=template&id=460d4d9c"
import script from "./IklanBaris.vue?vue&type=script&lang=js"
export * from "./IklanBaris.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports